import { Component, OnInit } from '@angular/core';

import * as $ from 'jquery';

import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {

  No_of_Print_Copies: any[] = [1, 2, 3];


  constructor(public _baseService: BaseService, public _config: ConfigService) {
  }

  ngOnInit() {


    if (!this._baseService.InvoiceData.invoice_no) {
      this._baseService.redirectTo('billing');

    }
    else {
      this._baseService.getRupeesInWords(this._baseService.InvoiceData.totalObject.GrandTotal);
    }

    this._baseService.getAllBanks();
    
  }


  printPage() {

    window.print();
  }




  saveAndPrintInvoice() {

    let postBody: any = this._baseService.InvoiceData;

    postBody.isAddOrder = true;

    let requestURL = this._config.baseURL + this._config.addOrder;
    let headerOption = this._baseService.commonheader();

    this._baseService.doPOST(requestURL, postBody, headerOption).subscribe((results: any) => {

      if (results.data)
        this._baseService.showSuccess(results.message);
      else
        this._baseService.showError(results.message);


      this.printPage();

    });


  }








}
